export default __webpack_public_path__ + "static/media/gallery - levicorpus_01.351c4b17.jpg";